export const details = [
  {
    id: 1,
    label: "Coin",
    value: "Bitcoin (BTC)",
  },
  {
    id: 2,
    label: "Amount",
    value: "0.0 • $17,17",
  },
  {
    id: 3,
    label: "Time",
    value: "06 Feb 2025 16:09:18 GMT+09",
  },
  {
    id: 4,
    label: "Hash",
    value: "61491cc8891b56b423f1de7134959d24e7172d8af0ece8ea265e1c0b31807ebb",
    underline: true,
  },
  {
    id: 5,
    label: "Transaction status",
    isStatus: true,
    value: "success",
    block: 70371052,
  },
  {
    id: 6,
    label: "Transaction status",
    isStatus: true,
    value: "error",
  },
  {
    id: 7,
    label: "Transaction status",
    isStatus: true,
    value: "pending",
  },
  {
    id: 8,
    label: "Contract",
    tooltip: "tooltip title",
    value: "TR7NH...zgjLj6t",
    copy: true,
    smartContract: true,
  },
  {
    id: 9,
    label: "Links",
    tooltip: "tooltip title",
    links: [
      {
        id: 1,
        label: "Official Website",
        href: "https://bitcoin.org/",
      },
      {
        id: 2,
        label: "White Paper",
        href: "https://bitcoin.org/bitcoin.pdf",
      },
      {
        id: 3,
        label: "Explorer",
        href: "https://blockchain.info/",
      },
    ],
  },
];

export const blockTable = [
  {
    id: 1,
    label: "Mined on",
    value: {
      title: "12 Mar 2025 10:56:49 UTC",
      subtitle: "(20 minutes ago)",
    },
  },
  {
    id: 2,
    label: "Guessed miner",
    value: {
      title: "Unknown",
    },
    underline: true,
  },
  {
    id: 3,
    label: "Transactions count",
    value: {
      title: 1871,
    },
    underline: true,
    comma: true,
  },
  {
    id: 4,
    label: "Fee per kB",
    value: {
      title: "0.0000057 BTC",
      subtitle: "0.47 USD",
    },
    icon: "check2",
  },
  {
    id: 5,
    label: "Witness tx count",
    value: {
      title: 1571,
    },
    underline: true,
    comma: true,
  },
  {
    id: 6,
    label: "Fee per kWU",
    value: {
      title: "0.0000057 BTC",
      subtitle: "0.47 USD",
    },
    icon: "check2",
  },
  {
    id: 7,
    label: "Inputs",
    value: {
      title: 1571,
    },
    underline: true,
    comma: true,
  },
  {
    id: 8,
    label: "Outputs",
    value: {
      title: 1571,
    },
    underline: true,
    comma: true,
  },
  {
    id: 9,
    label: "Input total",
    value: {
      title: "0.0000057 BTC",
      subtitle: "91,462,880 USD",
    },
    icon: "check2",
  },
  {
    id: 10,
    label: "Output total",
    value: {
      title: "1,107.42905453 BTC ",
      subtitle: "91,721,704 USD",
    },
    icon: "check2",
  },
  {
    id: 11,
    label: "Generation",
    value: {
      title: "3.125 BTC",
      subtitle: "258,825 USD",
    },
    icon: "check2",
  },
  {
    id: 12,
    label: "Reward",
    value: {
      title: "3.14776701 BTC",
      subtitle: "260,710 USD",
    },
    icon: "check2",
  },
  {
    id: 13,
    label: "Size",
    value: {
      title: 1580890,
    },
    comma: true,
  },
  {
    id: 14,
    label: "Weight",
    value: {
      title: 3993559,
    },
    comma: true,
  },
];

export const transactionsTableData = [
  // {
  //   transaction:
  //     "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
  //   address: "",
  //   type: "Main events",
  //   amount: {
  //     value: "3.14776701 BTC",
  //     fiat: "259,508.61 USD",
  //     type: "minus",
  //   },
  // },
  // {
  //   transaction:
  //     "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
  //   address: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
  //   type: "Omni Layer events",
  //   amount: {
  //     value: "3.14776701 BTC",
  //     fiat: "259,508.61 USD",
  //     type: "plus",
  //   },
  // },
  // {
  //   transaction:
  //     "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "script-3b6d765f...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "70a8e2...db27db",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "80b9f3...ec38ec",
  //   type: "Omni Layer events",
  //   amount: "+ 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "script-4c7d890a...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "80b9f3...ec38ec",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "90c1a4...fd49fd",
  //   type: "Omni Layer events",
  //   amount: "+ 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "script-5e8f901b...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "90c1a4...fd49fd",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "a0d2b5...ee5aee",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 0.87654321 BTC · 72,000.00 USD",
  // },
  // {
  //   transaction: "a0d2b5...ee5aee",
  //   address: "a0d2b5...ee5aee",
  //   type: "Omni Layer events",
  //   amount: "+ 0.87654321 BTC · 72,000.00 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "70a8e2...db27db",
  //   type: "Omni Layer events",
  //   amount: "+ 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "script-3b6d765f...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "70a8e2...db27db",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "70a8e2...db27db",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 3.14776701 BTC · 259,508.61 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "80b9f3...ec38ec",
  //   type: "Omni Layer events",
  //   amount: "+ 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "script-4c7d890a...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "80b9f3...ec38ec",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "80b9f3...ec38ec",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 2.12345678 BTC · 175,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "90c1a4...fd49fd",
  //   type: "Omni Layer events",
  //   amount: "+ 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "script-5e8f901b...",
  //   type: "Omni Layer events",
  //   amount: "+ 0 BTC · 0.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "90c1a4...fd49fd",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "90c1a4...fd49fd",
  //   address: "the-void",
  //   type: "Omni Layer events",
  //   amount: "- 1.98765432 BTC · 163,000.00 USD",
  // },
  // {
  //   transaction: "a0d2b5...ee5aee",
  //   address: "the-void",
  //   type: "Main events",
  //   amount: "- 0.87654321 BTC · 72,000.00 USD",
  // },
  // {
  //   transaction: "a0d2b5...ee5aee",
  //   address: "a0d2b5...ee5aee",
  //   type: "Omni Layer events",
  //   amount: "+ 0.87654321 BTC · 72,000.00 USD",
  // },
];

export const tokenTableData = [
  {
    hash: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    block: "70378072",
    age: "29 secs ago",
    from: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    to: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    type: "Main events",
    amount: "2,971",
    results: true,
  },
  {
    hash: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    block: "70378072",
    age: "29 secs ago",
    from: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    to: "c8b3d4e13d5d8a369b5518df3f18a3648154002ca70291733577e6adf1035c07",
    type: "Omni Layer events",
    amount: "2,971",
    results: false,
  },
];
